import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { format, parse } from "date-fns";
import { FaRoute } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import { getbusarrivaldetails } from "../../../services/Reportservice";
const formatTo12Hour = (timeStr) => {
  if (!timeStr) return "NA";

  try {
    // Extract only HH:mm:ss from time string
    const cleanTime = timeStr.split(".")[0]; // removes microseconds
    const [hours, minutes, seconds] = cleanTime.split(":").map(Number);

    if (
      isNaN(hours) ||
      isNaN(minutes) ||
      (seconds !== undefined && isNaN(seconds))
    ) {
      throw new Error("Invalid time format");
    }

    const date = new Date();
    date.setHours(hours, minutes, seconds || 0, 0);

    return format(date, "hh:mm a");
  } catch (error) {
    return "Invalid Time";
  }
};
const StopTimeline = ({ stops }) => (
  <div
    className="p-2"
    style={{
      position: "relative",
      margin: "0 auto",
    }}
  >
    {stops.map((stop, index) => {
      const isLast = index === stops.length - 1;
      const statusLower = stop.status?.toLowerCase();
      const reached = [
        "reached on time",
        "reached early",
        "reached delayed",
        "early",
        "delayed",
        "on time"
      ].some((s) => statusLower.includes(s));

      return (
        <div
          key={index}
          style={{
            display: "flex",
            position: "relative",
            paddingLeft: "30px",
            minHeight: "100px",
          }}
        >
          {/* Marker */}
          <div
            style={{
              position: "absolute",
              left: "0px",
              top: "2px",
              zIndex: 2,
            }}
          >
            <FaMapMarkerAlt
              color={reached ? "green" : "#ccc"}
              style={{ fontSize: "28px" }}
            />
          </div>

          {/* Connecting line */}
          {!isLast && (
            <div
              style={{
                position: "absolute",
                left: "13px",
                top: "32px",
                height: "70px",
                width: "2px",
                backgroundImage: `linear-gradient(${
                  reached ? "green" : "#ccc"
                } 40%, transparent 40%)`,
                backgroundSize: "2px 6px",
                backgroundRepeat: "repeat-y",
                zIndex: 1,
              }}
            />
          )}

          {/* Stop Info */}
          <div
            style={{
              fontSize: "14px",
              flex: 1,
              marginTop: "3px",
              marginLeft: "5px",
            }}
          >
            <div className="d-flex flex-wrap gap-2" style={{ fontWeight: "bold" }}>
              {stop?.stop?.name || "N/A"}
               <div>
              <span
                className={`badge ${
                  statusLower.includes("delayed")
                    ? "text-bg-danger-soft"
                    : statusLower.includes("not reached")
                    ? "text-bg-info-soft"
                    : "text-bg-success-soft"
                }`}
                style={{ fontSize: "12px" }}
              >
                {stop.status}
              </span>
            </div>
            </div>
            <div style={{ color: "#6c757d" }}>
              Scheduled: {formatTo12Hour(stop.schedule_time)}
            </div>
            <div style={{ color: "#6c757d" }}>
              Actual: {formatTo12Hour(stop.actual_time)}
            </div>
           
          </div>
        </div>
      );
    })}
  </div>
);

const Stopreport = ({ rowData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [errorMsg, setErrormMsg] = useState("");
  useEffect(() => {
    setLoading(true);
    getbusarrivaldetails(rowData?.id)
      .then((res) => {
        setData(res?.data || []);
      })
      .catch((err) => {
        setErrormMsg(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [rowData]);
  if (loading) {
    return (
      <div className="mt-3 text-center">
        <Spinner animation="border" />
      </div>
    );
  }
  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-2">
        <FaRoute className="text-primary" size={20} />
        <h5 className="m-0 text-dark">{rowData?.route?.name}</h5>
      </div>
      {data?.length > 0 ? (
        <StopTimeline stops={data} />
      ) : (
        <div className="text-center mt-2">No data found</div>
      )}
    </div>
  );
};

export default Stopreport;
